import { useTheme } from '@mui/material'
import { Checkbox, Stack, Typography } from '@mui/material'
import React from 'react'

interface CheckBoxContainerProps {
    checked: boolean
    onClick: () => void
    label: string
}

const CheckBoxContainer: React.FC<CheckBoxContainerProps> = ({ checked, onClick, label }: CheckBoxContainerProps) => {
    const theme = useTheme()
    return (
        <Stack bgcolor={theme.palette.tableHeader.default} maxHeight={40} p={2} borderRadius={1} direction='row' alignItems='center' justifyContent='space-between' width='100%'>
            <Typography variant='body1'>{label}</Typography>
            <Checkbox
                checked={checked}
                onClick={onClick}
            />
        </Stack>
    )
}

export default CheckBoxContainer